<template>
  <div class='mains'>
    <div class='pic mar1'>
      <div class='desc'>
        <h3>关于我们</h3>
        <p class='word' v-html="message"></p>
      </div>
      <img :src='src2' class="imgs"/>
    </div>
  </div>
</template>
<script>
  import config from '@/api/config.js'
  import axios from 'axios';
	export default {
		name: 'homeContent',
		data () {
			return {
				src2: '',
				message: ''
			}
		},
		created() {
			this.getIndexData();
		},
		methods: {
			async getIndexData() {
				try {
					const response = await axios.get(config.baseUrl + '/index/pc');
					this.src2 = response.data.data.about.image;
					this.message = response.data.data.about.message;
				} catch (error) {
					console.error('请求失败:', error);
				}
			},
		},
	}
</script>
<style lang='scss'>
	.mains {
    max-width: 1200px;
    margin: 0 auto;
		.imgs {
			width: 400px;
			height: 400px;
		}
    .pic {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
	}
	
	.desc{
    width: 360px;
    margin-left: 114px;
		 h3 {
			font-size: 36px;
			color: #666666;
			font-weight: 500;
      text-align: left;
		}
	}
	.word{
		font-size: 14px;
		color: #8D8D8D;
		line-height: 22px;
		margin: 0;
		padding: 0;
    padding-bottom: 10px;
	}
	.mar1{
		margin: 50px 0 50px;
	}
</style>


// WEBPACK FOOTER //
// homeContent.vue?45200182